import { createIdentifier } from '@blocksuite/global/di';
import type { ExtensionType } from '@blocksuite/store';

export type DateSelectorPosition = [number, number, number, number];

export interface JournalService {
  ensureJournalDoc(date: string): string;
  selectDate?(position?: DateSelectorPosition): Promise<string | undefined>;
}

export const JournalProvider = createIdentifier<JournalService>(
  'AffineJournalService'
);

export function JournalExtension(
  journalService: JournalService
): ExtensionType {
  return {
    setup: di => {
      di.addImpl(JournalProvider, journalService);
    },
  };
}
